import { dependencies, Dependencies } from "../dependencies";


export class BaseService {
    protected dependencies: Dependencies;
    constructor() {
        this.dependencies = dependencies;
    }
}
